import React, {useMemo} from 'react';
import {useSeasonThemeTableData} from "../../logs/useTableData";
import {Button, Input} from "antd";
import IsLoading from "../../../shared/components/IsLoading";
import ErrorPage from "../../../shared/components/ErrorPage";
import TablePage from "../../../pages/tablePage/TablePage";
import {SeasonThemeMasterEntity} from "./SeasonThemeMasterEntity";
import {SeasonThemeMasterTableEntity} from "./SeasonThemeMasterTableEntity";
import {
    saveSeasonThemeMaster
} from "./useSeasonThemeMaster";
import {useGameDataConfig, useSaveGameDataConfig} from "../../../pages/csv/useCSVList";
import {DATA_CONFIG_KEY} from "../../../shared/utils/enum";

const SeasonThemeTable = () => {
    const {data, isLoading, error} = useSeasonThemeTableData();
    const {data: dataConfig, isLoading: isDataConfigLoading, error: dataConfigError} = useGameDataConfig(DATA_CONFIG_KEY.SEASON_THEME_MEMO);
    const {mutate: saveDataConfig} = useSaveGameDataConfig();

    const saveDataConfigMemo = async (index, memo) => {
        const newDataConfig = {...dataConfig, [index]: memo};
        saveDataConfig({config: newDataConfig, key: DATA_CONFIG_KEY.SEASON_THEME_MEMO});
    }

    const handleSave = async (record) => {
        const row = new SeasonThemeMasterEntity(record);
        if (row.isInvalidate()) return;
        await saveSeasonThemeMaster(row.toJson());
    }

    const columns = useMemo(() => [
        {
            title: '인덱스',
            dataIndex: 'index',
            key: 'index',
            sorter: (a, b) => a.index - b.index,
        },
        {
            title: '시즌테마 이름',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: '리소스 번호',
            dataIndex: 'resourceIdx',
            key: 'resourceIdx',
        },
        {
            title: '오픈 레벨',
            dataIndex: 'openLevel',
            key: 'openLevel',
            render: (openLevel) => openLevel?.toString()
        },
        {
            title: '시즌 그룹',
            dataIndex: 'seasonGIdx',
            key: 'seasonGIdx',
            render: (seasonGIdx) => seasonGIdx?.toString()
        },
        {
            title: '메모',
            key: 'memo',
            render: (_, row) => {
                return (<Input
                    key={`memo-${row.index}-${dataConfig?.[row.index] || ''}`}
                    type="text"
                    defaultValue={ dataConfig ? dataConfig[row.index] || '' : '' }
                    style={{ width: '100%' }}
                    onBlur={(e) => saveDataConfigMemo(row.index, e.target.value)}
                    onPressEnter={(e) => saveDataConfigMemo(row.index, e.target.value)}
                />);
            }
        },
        {
            title: '액션',
            render: (record) => (
                <Button onClick={() => handleSave(record)}>
                    {'추가하기'}
                </Button>
            )
        }
    ], [dataConfig]);

    if (isLoading || isDataConfigLoading) return <IsLoading/>;
    const err = error || dataConfigError;
    if (error || dataConfigError) return <ErrorPage error={err}/>;

    const props = {
        columns,
        isLoading: isLoading,
        localData: data || [],
        entityModel: SeasonThemeMasterTableEntity,
    }

    return (
        <TablePage
            {...props}
        />
    );
};

export default SeasonThemeTable;